import {Base} from "@/api/Base"

export class PolicyEdit extends Base {
    path = "policy/edit"
}